/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Period_DescInputs */

const tr_iade_iptal_s2_period_desc = /** @type {(inputs: Iade_Iptal_S2_Period_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık veya yıllık olarak satın alınan ücretli kullanım dönemi.`)
};

const en_iade_iptal_s2_period_desc = /** @type {(inputs: Iade_Iptal_S2_Period_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The paid usage period purchased on a monthly or annual basis.`)
};

const de_iade_iptal_s2_period_desc = /** @type {(inputs: Iade_Iptal_S2_Period_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der monatlich oder jährlich erworbene kostenpflichtige Nutzungszeitraum.`)
};

const ru_iade_iptal_s2_period_desc = /** @type {(inputs: Iade_Iptal_S2_Period_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платный период использования, приобретённый на месяц или на год.`)
};

/**
* | output |
* | --- |
* | "The paid usage period purchased on a monthly or annual basis." |
*
* @param {Iade_Iptal_S2_Period_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_period_desc = /** @type {((inputs?: Iade_Iptal_S2_Period_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Period_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_period_desc(inputs)
	if (locale === "de") return de_iade_iptal_s2_period_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_period_desc(inputs)
	return tr_iade_iptal_s2_period_desc(inputs)
});